import { Row, Col, Button } from 'antd';
import T from 'prop-types';
import {
  PlayCircleFilled,
  PauseCircleFilled,
  MinusOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import React from 'react';
import FormatUtils from '../../../utils/FormatUtils';
import { FormattedMessage } from 'react-intl';

const ZOOM_MAX = 5;
const ZOOM_MIN = 1;

const Controls = ({
  episodeDuration,
  isPlaying,
  isPlayingAd,
  isAudioLoading,
  currentTime,
  zoomLevel,
  setZoomLevel,
  audioElement,
}) => {
  const handlePlayToggle = () => {
    if (audioElement.paused) {
      audioElement.play();
    } else {
      audioElement.pause();
    }
  };

  const handleZoomIn = () => {
    const z = Math.min(zoomLevel + 1, ZOOM_MAX);
    setZoomLevel(z);
  };

  const handleZoomOut = () => {
    const z = Math.max(zoomLevel - 1, ZOOM_MIN);
    setZoomLevel(z);
  };

  return (
    <>
      <Row
        gutter={{ xs: 14, sm: 14, md: 30, lg: 30, xxl: 30 }}
        align="middle"
        className="editor-controls"
      >
        <Col span={8}>
          <Row gutter={8} align="middle">
            <Col>
              <Button
                disabled={isPlayingAd}
                loading={isAudioLoading}
                icon={isPlaying ? <PauseCircleFilled /> : <PlayCircleFilled />}
                onClick={handlePlayToggle}
              >
                {isPlayingAd ? (
                  <FormattedMessage defaultMessage="Playing Ad" />
                ) : isPlaying ? (
                  <FormattedMessage defaultMessage="Pause" />
                ) : (
                  <FormattedMessage defaultMessage="Play" />
                )}
              </Button>
            </Col>
            <Col>
              <span>
                {FormatUtils.msTohmsms(currentTime * 1000, { ms: false })} /{' '}
                {FormatUtils.msTohmsms(episodeDuration * 1000, { ms: false })}
              </span>
            </Col>
          </Row>
        </Col>

        <Col span={16}>
          <Row gutter={8} align="end" className="editor-controls__zoom">
            <Col>
              <Button size="small" icon={<MinusOutlined />} onClick={handleZoomOut} />
            </Col>
            <Col>
              <span>{zoomLevel * 100}%</span>
            </Col>
            <Col>
              <Button size="small" icon={<PlusOutlined />} onClick={handleZoomIn} />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

Controls.propTypes = {
  episodeDuration: T.number,
  isPlaying: T.bool,
  isPlayingAd: T.bool,
  isAudioLoading: T.bool,
  currentTime: T.number,
  zoomLevel: T.number,
  setZoomLevel: T.func,
  audioElement: T.object,
};

export default Controls;
